import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import apiFetch from './api';

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState({ loading: true, authenticated: false });

  useEffect(() => {
    let isMounted = true;
    apiFetch('/api/auth/status', {
      headers: { 'Accept': 'application/json' }
    })
      .then(async (res) => {
        if (res.ok) {
          const data = await res.json();
          if (isMounted) setStatus({ loading: false, authenticated: !!data.authenticated });
        } else if (res.status === 401) {
          if (isMounted) setStatus({ loading: false, authenticated: false });
        } else {
          // Treat other unexpected statuses as unauthenticated
          if (isMounted) setStatus({ loading: false, authenticated: false });
        }
      })
      .catch(() => {
        if (isMounted) setStatus({ loading: false, authenticated: false });
      });

    return () => { isMounted = false; };
  }, []);

  if (status.loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Checking authentication…</div>;
  }

  if (!status.authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
